import { combineReducers } from '@reduxjs/toolkit';
import apiSettings, { APISettingsState } from './APISettingsReducer';

export type DistributionState = {
  apiSettings: APISettingsState;
};

const distributionReducer = combineReducers({
  apiSettings,
});

export default distributionReducer;
